import { useIsAuthenticated } from "@azure/msal-react";
import { PropsWithChildren } from "react";
import { useRoles } from "./RoleProvider";

type Props = {
  requiredRoles: string[];
};

export default function RenderAuthorized({ requiredRoles, children }: PropsWithChildren<Props>) {
  const { roles } = useRoles();
  const isAuthenticated = useIsAuthenticated();

  if (requiredRoles.length === 0) {
    return isAuthenticated ? <div>{children}</div> : null;
  }

  return isAuthenticated && roles.some((role) => requiredRoles.indexOf(role) >= 0) ? (
    <div>{children}</div>
  ) : null;
}
